export default __webpack_public_path__ + "static/media/collapse-icon.29eac5c5.svg";